<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import { urlMethods } from "@/state/helpers";
import Swal from "sweetalert2";
export default {
  components: {},
  data: function() {
    return {
      pops: "",
      isLoading: false,
    };
  },
  props: ["orderDetail", "orderLines"],
  computed: {
    currentUser: function() {
      return this.$store.getters["auth/currentUser"];
    },
  },
  methods: {
    ...urlMethods,
    closePopup() {
      this.$bvModal.hide("modal-so-detail");
    },
  },
  mounted() {},
};
</script>

<template>
  <div>
    <b-modal
      id="modal-so-detail"
      title="Chi Tiết Đơn Hàng"
      title-class="font-18"
      hide-footer
    >
      <table style="margin: -1rem"
        class="table table-striped"
        v-if="orderDetail"
      >
        <tbody>
          <tr>
            <th style="white-space: nowrap;">Khách hàng</th>
            <td>
              {{
                orderDetail.customer_name
              }}
            </td>
          </tr>
          <tr>
            <th style="white-space: nowrap;">Kho xuất</th>
            <td>{{ orderDetail.warehouse_name }}</td>
          </tr>
          <tr>
            <th style="white-space: nowrap;">ĐV vận chuyển</th>
            <td>{{ orderDetail.transporter }}</td>
          </tr>
          <tr>
            <th style="white-space: nowrap;">Mã đơn sàn</th>
            <td>{{ orderDetail.shipment_id }}</td>
          </tr>
          <tr>
            <th style="white-space: nowrap;">Mã vận đơn</th>
            <td>{{ orderDetail.shipment_code }}</td>
          </tr>
        </tbody>
      </table>

      <div class="clear clearfix"></div>
      <table
        id="tbProduct"
        class="table table-bordered table-striped"
        v-if="orderLines"
      >
        <thead>
          <tr>
            <th>Tên Sản Phẩm</th>
            <th>Số Lượng</th>
            <th>Đơn giá</th>
            <th>Chiết khấu (%)</th>
            <th>Thành tiền</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in orderLines" :key="index">
            <td>{{ product.name }}</td>
            <td>{{ product.qty }}</td>
            <td>{{ product.price }}</td>
            <td>{{ product.discount }}</td>
            <td>{{ product.total }}</td>
          </tr>
        </tbody>
      </table>
      <div class="clear clearfix"></div>

      <table
        style="margin-bottom: 0px !important; float: right; width: 270px;"
        class="table table-striped"
        v-if="orderDetail"
      >
        <tbody>
          <tr>
            <td style="width:50%">Tổng hoá đơn:</td>
            <td style="text-align: right">
              <b>{{ parseFloat(orderDetail.total).toLocaleString() + " ₫" }}</b>
            </td>
          </tr>
          <tr>
            <td style="width:50%">Tổng COD:</td>
            <td style="text-align: right">
              <b>{{ parseFloat(orderDetail.cod).toLocaleString() + " ₫" }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="clear clearfix"></div>
    </b-modal>
  </div>
</template>
